<script>import { Elements, PaymentElement } from 'svelte-stripe';
import { createEventDispatcher } from "svelte";
export let stripe;
export let clientSecret;
export let showTerms = true;
let processing = false;
let elements;
let error = null;
const dispatch = createEventDispatcher();
async function submit() {
    if (processing)
        return;
    processing = true;
    const result = await stripe
        .confirmPayment({
        elements,
        redirect: 'if_required'
    });
    console.log({ result });
    if (result.error) {
        error = result.error;
        processing = false;
    }
    else {
        dispatch("paymentComplete", { paymentIntent: result.paymentIntent });
        processing = false;
    }
}
</script>

{#if error}
    <p class=error>{error.message} Please try again.</p>
{/if}

<form on:submit|preventDefault={submit}>
    <Elements
            {stripe}
            {clientSecret}
            bind:elements
            theme="flat"
            labels="floating"
            variables={{ colorPrimary: "#7c4dff" }}
            rules={{ ".Input": { border: "solid 1px #0002" } }}
    >
        <PaymentElement/>
    </Elements>

    <button disabled={processing}>
        {#if processing}
            Processing...
        {:else}
            Pay
        {/if}
    </button>

    {#if showTerms}
        <p>By clicking this Pay button, I acknowledge that I am accepting the <a target="_blank"
                                                                                 href="https://www.thesmartwashltd.com/our-policy">Terms
            and Conditions</a> of The Smart Wash Ltd</p>
    {/if}
</form>

<style>
    .error {
        color: tomato;
        margin: 2rem 0 0;
    }

    form {
        display: flex;
        flex-direction: column;
        gap: 10px;
        max-width: 400px;
        margin: auto auto;
    }

    button {
        padding: 1rem;
        border-radius: 5px;
        border: solid 1px #ccc;
        font-size: 1.2rem;
        margin: 1rem 0;
    }
</style>
